import { useCallback, useContext, useMemo, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { TaskContext } from 'context/TaskContext';
import { TaskContextType } from 'context/TaskContext/types';
import { Question } from 'dashboard409a/pages/Information/types';
import TaskStatusLabel from 'pages/ProcessManagement/components/TaskStatusLabel/TaskStatusLabel';
import StyledPerfectScrollbar from './ProcessManagementQuestionsForm.styles';
import ProcessManagementQuestionsFormInput from './ProcessManagementQuestionsFormInput/ProcessManagementQuestionsFormInput';
import styles from './ProcessManagementQuestionsFormInput/ProcessManagementQuestionsFormTextInput/styles';

const ProcessManagementQuestionsForm = () => {
  const { requestedQuestions } = useContext(TaskContext) as TaskContextType;
  const [editableQuestionId, setEditableQuestionId] = useState<number | null>(null);

  const getQuestionStatus = useCallback((question: Question) => question.answered ?? !isEmpty(question.answers), []);

  const handleClickSaveAgain = useCallback((questionId: number) => {
    setEditableQuestionId(questionId);
  }, []);

  const questionStatuses = useMemo(
    () => requestedQuestions.map((question: Question) => getQuestionStatus(question)),
    [requestedQuestions, getQuestionStatus]
  );

  return (
    <StyledPerfectScrollbar options={{ suppressScrollX: true, wheelSpeed: 3 }}>
      {requestedQuestions.map((question: Question, index: number) => {
        const questionStatus = questionStatuses[index];

        return (
          <Box
            key={question.id}
            marginBottom={4}
            display="flex"
            justifyContent="space-between"
            data-testid="process-management-question-card"
            data-question-id={question.id}>
            <Box display="flex" flexDirection="column" width="70%">
              <Typography style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem' }}>
                {index + 1}- {question.name}
              </Typography>
              {editableQuestionId === question.id || !questionStatus ? (
                <ProcessManagementQuestionsFormInput
                  question={question}
                  getQuestionStatus={getQuestionStatus}
                  setEditableQuestionId={setEditableQuestionId}
                />
              ) : (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => handleClickSaveAgain(question.id)}
                  style={styles.saveButton}>
                  Save Again
                </Button>
              )}
            </Box>
            <div>
              <TaskStatusLabel
                label={questionStatus ? 'answered' : 'not yet answered'}
                status={questionStatus ? 'completed' : 'notStarted'}
              />
            </div>
          </Box>
        );
      })}
    </StyledPerfectScrollbar>
  );
};

export default ProcessManagementQuestionsForm;
